var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.78 2.66602H10.2213C5.70264 2.66602 2.66797 5.83668 2.66797 10.5553V21.4447C2.66797 26.162 5.70264 29.3327 10.2213 29.3327H21.7786C26.2973 29.3327 29.3346 26.162 29.3346 21.4447V10.5553C29.3346 5.83668 26.2986 2.66602 21.78 2.66602Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7925 12.5312C13.3525 12.5312 14.6592 13.5712 15.0858 14.9979H22.6858C23.2325 14.9979 23.6858 15.4513 23.6858 15.9979V18.4646C23.6858 19.0246 23.2325 19.4646 22.6858 19.4646C22.1258 19.4646 21.6858 19.0246 21.6858 18.4646V16.9979H19.9125V18.4646C19.9125 19.0246 19.4592 19.4646 18.9125 19.4646C18.3525 19.4646 17.9125 19.0246 17.9125 18.4646V16.9979H15.0858C14.6592 18.4246 13.3525 19.4646 11.7925 19.4646C9.8725 19.4646 8.3125 17.9179 8.3125 15.9979C8.3125 14.0912 9.8725 12.5312 11.7925 12.5312ZM11.7925 14.5312C10.9792 14.5312 10.3125 15.1846 10.3125 15.9979C10.3125 16.8113 10.9792 17.4646 11.7925 17.4646C12.5925 17.4646 13.2592 16.8113 13.2592 15.9979C13.2592 15.1846 12.5925 14.5312 11.7925 14.5312Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.88c472a72ed1b37c679b639fa4ebf60e.svg";
export { ForwardRef as ReactComponent };